/*
 * Simple Bundles BYOB product-page shipping bridge.
 *
 * For /products/build_your-own_box (and test-build_your-own_box):
 * injects the KS shipping selector near the Simple Bundles widget and
 * requires a shipping choice before the app's Add to Cart can proceed.
 *
 * Does NOT touch homepage ks-byob-builder.*. Checkout guard remains the
 * final backstop for missing line properties / note / marker.
 */
(function () {
    "use strict";

    var HANDLES = ["build_your-own_box", "test-build_your-own_box"];
    var ROOT_ATTR = "data-ks-sb-byob-shipping";
    var BOUND_ATTR = "data-ks-sb-byob-shipping-bound";
    var PANEL_ID = "ks-sb-byob-shipping-panel";
    var ALLOW_ATTR = "data-ks-sb-byob-shipping-allow";

    var _busy = false;
    var _panelRef = null;
    var _placedStable = false;
    var _placing = false;
    var _placeTimer = null;

    function cfg() {
        return window.KS_SB_BYOB_SHIPPING || null;
    }

    function isTargetPage() {
        var c = cfg();
        if (c && c.handle) {
            return HANDLES.indexOf(String(c.handle)) !== -1;
        }
        try {
            var path = window.location.pathname || "";
            return HANDLES.some(function (h) {
                return (
                    path.indexOf("/products/" + h) !== -1 ||
                    path.indexOf("/products/" + encodeURIComponent(h)) !== -1
                );
            });
        } catch (_) {
            return false;
        }
    }

    function debugLog() {
        try {
            if (!/(?:\?|&)ks_shipping_debug=1(?:&|$)/.test(window.location.search || "")) {
                return;
            }
            var args = Array.prototype.slice.call(arguments);
            args.unshift("[KS SbByobShipping]");
            console.log.apply(console, args);
        } catch (_) {
            /* ignore */
        }
    }

    function getKS() {
        return window.KSShippingOption || null;
    }

    function getGate() {
        return window.KSShippingGate || null;
    }

    function findByobBundle() {
        return document.querySelector("byob-bundle");
    }

    function findTemplate() {
        return document.getElementById("ks-sb-byob-shipping-template");
    }

    function getPanel() {
        if (_panelRef && _panelRef.isConnected) return _panelRef;
        var byId = document.getElementById(PANEL_ID);
        if (byId) {
            _panelRef = byId;
            return byId;
        }
        return _panelRef;
    }

    function isInShadow(node) {
        if (!node || !node.getRootNode) return false;
        try {
            var root = node.getRootNode();
            return Boolean(root && root.host);
        } catch (_) {
            return false;
        }
    }

    function collectButtons(root, out, depth) {
        if (!root) return out;
        out = out || [];
        depth = depth || 0;
        // Keep this shallow — deep walks on every mutation freeze the page.
        if (depth > 4) return out;

        var list = [];
        try {
            if (root.querySelectorAll) {
                list = root.querySelectorAll(
                    "button, [role='button'], a, input[type='submit'], input[type='button']"
                );
            }
        } catch (_) {
            list = [];
        }
        for (var i = 0; i < list.length; i++) out.push(list[i]);

        if (root.shadowRoot && depth === 0) {
            collectButtons(root.shadowRoot, out, depth + 1);
        }
        return out;
    }

    function buttonLabel(btn) {
        return (
            (btn.getAttribute && btn.getAttribute("aria-label")) ||
            btn.textContent ||
            btn.value ||
            ""
        )
            .replace(/\s+/g, " ")
            .trim()
            .toLowerCase();
    }

    function findCtaButton(root) {
        if (!root) return null;
        var buttons = [];
        try {
            buttons = root.querySelectorAll(
                "button, [role='button'], a, input[type='submit'], input[type='button']"
            );
        } catch (_) {
            return null;
        }

        var best = null;
        for (var i = 0; i < buttons.length; i++) {
            var label = buttonLabel(buttons[i]);
            if (
                /add bundle to cart|add to cart|add box to cart|add to bag/.test(
                    label
                )
            ) {
                return buttons[i];
            }
            // Same CTA while incomplete: "+ ADD 4 MORE"
            if (/add\s+\d+\s+more|add more|add bundle|add box/.test(label)) {
                best = best || buttons[i];
            }
        }
        return best;
    }

    function findAddBundleButton(bundle) {
        if (!bundle) return null;
        var inLight = findCtaButton(bundle);
        if (inLight) return inLight;
        if (bundle.shadowRoot) return findCtaButton(bundle.shadowRoot);
        return null;
    }

    function insertAfter(referenceNode, newNode) {
        if (!referenceNode || !referenceNode.parentNode || !newNode) return false;
        if (referenceNode.nextElementSibling === newNode) return true;
        if (referenceNode.nextSibling) {
            referenceNode.parentNode.insertBefore(
                newNode,
                referenceNode.nextSibling
            );
        } else {
            referenceNode.parentNode.appendChild(newNode);
        }
        return true;
    }

    function ensureShadowStyles(shadowRoot) {
        if (!shadowRoot || shadowRoot.getElementById("ks-sb-byob-shipping-styles")) {
            return;
        }
        var style = document.createElement("style");
        style.id = "ks-sb-byob-shipping-styles";
        style.textContent =
            ".ks-sb-byob-shipping{display:block;box-sizing:border-box;width:100%;margin:0.75rem 0 0;padding:0.85rem 0.9rem;border:1px solid rgba(25,69,113,.22);border-radius:12px;background:rgba(255,255,255,.98);color:#10263d;font-family:inherit;}" +
            ".ks-sb-byob-shipping__intro{margin:0 0 .5rem;font-size:.8125rem;line-height:1.35;color:rgba(16,38,61,.78);}" +
            ".ks-sb-byob-shipping .ks-shipping-option{margin:0;}" +
            ".ks-sb-byob-shipping .ks-shipping-option__label{display:block;font-size:.875rem;font-weight:700;margin:0 0 .35rem;}" +
            ".ks-sb-byob-shipping .ks-shipping-option__helper{font-size:.75rem;line-height:1.35;margin:0 0 .45rem;color:rgba(16,38,61,.7);}" +
            ".ks-sb-byob-shipping .ks-shipping-option__select{width:100%;max-width:100%;box-sizing:border-box;min-height:42px;padding:.45rem .65rem;border:1px solid rgba(25,69,113,.44);border-radius:8px;background:#fff;font:inherit;}" +
            ".ks-sb-byob-shipping .ks-shipping-option__estimate{margin-top:.5rem;font-size:.75rem;}" +
            ".ks-sb-byob-shipping .ks-shipping-option__error{margin:.45rem 0 0;font-size:.75rem;color:#c0392b;}" +
            ".ks-sb-byob-shipping .ks-shipping-option--invalid .ks-shipping-option__select{border-color:#c0392b;}";
        shadowRoot.appendChild(style);
    }

    function findCartColumn(shadowRoot) {
        if (!shadowRoot || !shadowRoot.querySelector) return null;
        var selectors = [
            '[part="cart"]',
            '[part="sidebar"]',
            '[part="summary"]',
            "[data-cart]",
            "aside",
            '[class*="Cart" i]',
            '[class*="cart" i]',
            '[class*="sidebar" i]',
            '[class*="summary" i]',
            '[class*="footer" i]',
        ];
        for (var i = 0; i < selectors.length; i++) {
            try {
                var hit = shadowRoot.querySelector(selectors[i]);
                if (hit) return hit;
            } catch (_) {
                /* ignore invalid selector */
            }
        }
        return null;
    }

    /**
     * Dock under the right-column CTA ("+ Add Bundle to Cart" / "+ ADD N MORE").
     * Prefer the widget shadow tree so we land in the cart column, not page chrome.
     */
    function placePanelInSidebar(panel, bundle) {
        if (!panel || !bundle || _placing) return false;
        _placing = true;

        try {
            var root = bundle.shadowRoot;
            if (!root) return false;

            ensureShadowStyles(root);

            var atc = findCtaButton(root);
            if (atc) {
                if (atc.nextElementSibling === panel) {
                    _placedStable = true;
                    _panelRef = panel;
                    return true;
                }
                insertAfter(atc, panel);
                _placedStable = true;
                _panelRef = panel;
                panel.classList.add("ks-sb-byob-shipping--docked");
                debugLog("placed shipping panel under CTA in shadow cart");
                return true;
            }

            var col = findCartColumn(root);
            if (col) {
                if (panel.parentNode !== col) col.appendChild(panel);
                _placedStable = true;
                _panelRef = panel;
                panel.classList.add("ks-sb-byob-shipping--docked");
                debugLog("placed shipping panel at end of shadow cart column");
                return true;
            }

            return false;
        } catch (err) {
            debugLog("placePanel failed", err);
            return false;
        } finally {
            _placing = false;
        }
    }

    function clearPanelError(panel) {
        if (!panel) return;
        panel.classList.remove("ks-shipping-option--invalid");
        var nested = panel.querySelector(".ks-shipping-option");
        if (nested) nested.classList.remove("ks-shipping-option--invalid");
        panel.querySelectorAll(".ks-shipping-option__error").forEach(function (el) {
            el.hidden = true;
        });
    }

    function mountPanel() {
        var existing = getPanel();
        var bundle = findByobBundle();

        if (existing) {
            _panelRef = existing;
            if (bundle && !_placedStable) {
                placePanelInSidebar(existing, bundle);
            }
            return existing;
        }

        var template = findTemplate();
        var node = null;

        if (template && template.content) {
            node = template.content.firstElementChild
                ? template.content.firstElementChild.cloneNode(true)
                : null;
        }

        if (!node) {
            node = document.createElement("div");
            node.className = "ks-sb-byob-shipping ks-shipping-option";
            node.setAttribute(ROOT_ATTR, "");
            node.innerHTML =
                '<p class="ks-shipping-option__helper">Choose a shipping option before adding your box to cart.</p>' +
                '<button type="button" class="button button--secondary" data-ks-sb-byob-open-gate>Choose shipping option</button>';
        }

        node.id = PANEL_ID;
        node.setAttribute(ROOT_ATTR, "");
        _panelRef = node;
        _placedStable = false;

        var placed = bundle ? placePanelInSidebar(node, bundle) : false;
        if (!placed) {
            var hold =
                document.getElementById("ks-sb-byob-shipping-hold") ||
                document.createElement("div");
            hold.id = "ks-sb-byob-shipping-hold";
            hold.hidden = true;
            if (!hold.parentNode) document.body.appendChild(hold);
            if (node.parentNode !== hold) hold.appendChild(node);
            debugLog("holding shipping panel until byob-bundle exists");
        }

        var KS = getKS();
        if (KS && typeof KS.init === "function") {
            KS.init(node);
        }

        clearPanelError(node);

        var openBtn = node.querySelector("[data-ks-sb-byob-open-gate]");
        if (openBtn && !openBtn.__ksSbBound) {
            openBtn.__ksSbBound = true;
            openBtn.addEventListener("click", function () {
                openGateFallback();
            });
        }

        debugLog("mounted shipping panel");
        return node;
    }

    function selectedShippingValue(panel) {
        var KS = getKS();
        if (!KS) return "";
        if (panel && typeof KS.getSelectedOption === "function") {
            var fromPanel = KS.getSelectedOption(panel);
            if (fromPanel) return fromPanel;
        }
        if (typeof KS.getStoredOption === "function") {
            return KS.getStoredOption() || "";
        }
        return "";
    }

    function persistShipping(value) {
        var KS = getKS();
        if (!KS || !value) return Promise.resolve(false);

        if (typeof KS.saveStoredOption === "function") {
            KS.saveStoredOption(value);
        }

        var chain = Promise.resolve();
        if (typeof KS.syncCartAttribute === "function") {
            chain = chain.then(function () {
                return KS.syncCartAttribute(value);
            });
        }
        if (typeof KS.syncShippingMarker === "function") {
            chain = chain.then(function () {
                return KS.syncShippingMarker(value);
            });
        }
        return chain
            .then(function () {
                debugLog("persisted shipping", value);
                return true;
            })
            .catch(function (err) {
                debugLog("persist failed", err);
                return true; // checkout guard remains the backstop
            });
    }

    function openGateFallback() {
        var Gate = getGate();
        var c = cfg() || {};
        if (!Gate || typeof Gate.openPicker !== "function") {
            return Promise.resolve(null);
        }
        return Gate.openPicker({
            trigger: document.activeElement,
            productTitle: c.productTitle || "",
        }).then(function (result) {
            if (!result || !result.shippingValue) return null;
            // persistSelection already ran inside gate confirm; still sync note/marker.
            return persistShipping(result.shippingValue).then(function () {
                var panel = getPanel();
                var KS = getKS();
                if (panel && KS && typeof KS.setSelectedOption === "function") {
                    KS.setSelectedOption(result.shippingValue, panel);
                }
                return result;
            });
        });
    }

    function ensureShippingBeforeAdd() {
        var panel = mountPanel();
        var KS = getKS();
        var value = selectedShippingValue(panel);

        if (value && KS && typeof KS.isValidShippingOption === "function") {
            if (!KS.isValidShippingOption(value)) value = "";
        } else if (value && KS && typeof KS.normalizeShippingOption === "function") {
            value = KS.normalizeShippingOption(value);
        }

        if (value) {
            if (panel && KS && typeof KS.validate === "function") {
                KS.validate(panel);
            }
            return persistShipping(value).then(function () {
                return value;
            });
        }

        if (panel && KS && typeof KS.validate === "function") {
            KS.validate(panel);
            try {
                panel.scrollIntoView({ behavior: "smooth", block: "center" });
            } catch (_) {
                panel.scrollIntoView && panel.scrollIntoView();
            }
        }

        return openGateFallback().then(function (result) {
            return result && result.shippingValue ? result.shippingValue : "";
        });
    }

    function eventPath(event) {
        if (event && typeof event.composedPath === "function") {
            try {
                return event.composedPath();
            } catch (_) {
                /* ignore */
            }
        }
        var path = [];
        var node = event && event.target;
        while (node) {
            path.push(node);
            node = node.parentNode || node.host;
        }
        return path;
    }

    function findInPath(event, matcher) {
        var path = eventPath(event);
        for (var i = 0; i < path.length; i++) {
            var el = path[i];
            if (!el || el.nodeType !== 1) continue;
            if (matcher(el)) return el;
        }
        return null;
    }

    function isFinalBundleCartLabel(label) {
        var text = String(label || "")
            .replace(/\s+/g, " ")
            .trim()
            .toLowerCase();
        if (!text) return false;

        // Incomplete-box CTAs must never open shipping.
        if (/add\s+\d+\s+more|\bmore\b/.test(text) && !/cart|bag/.test(text)) {
            return false;
        }
        if (/^\+?\s*add\s*$/.test(text)) return false;

        return /add bundle to cart|add to cart|add box to cart|add to bag/.test(
            text
        );
    }

    function isAddToCartTarget(event) {
        var bundle = findInPath(event, function (el) {
            return el.tagName && el.tagName.toLowerCase() === "byob-bundle";
        });
        if (!bundle) return null;

        var btn = findInPath(event, function (el) {
            if (!el.tagName) return false;
            var tag = el.tagName.toLowerCase();
            return (
                tag === "button" ||
                tag === "a" ||
                (tag === "input" &&
                    (el.type === "submit" || el.type === "button")) ||
                el.getAttribute("role") === "button"
            );
        });
        if (!btn) return null;

        if (btn.getAttribute && btn.getAttribute(ALLOW_ATTR) === "1") {
            return null;
        }

        // Never intercept pack tiles, variants, or box-size tabs.
        var inPackChrome = findInPath(event, function (el) {
            var tag = el.tagName && el.tagName.toLowerCase();
            return (
                tag === "byob-pack" ||
                tag === "byob-variant" ||
                tag === "byob-product" ||
                tag === "byob-section" ||
                (el.classList &&
                    (el.classList.contains("quantity") ||
                        el.classList.contains("qty")))
            );
        });
        if (inPackChrome) return null;

        var label = (
            (btn.getAttribute && btn.getAttribute("aria-label")) ||
            btn.textContent ||
            btn.value ||
            ""
        )
            .replace(/\s+/g, " ")
            .trim()
            .toLowerCase();

        if (
            /minus|plus|decrease|increase|remove|quantity|qty|^[\+\-\u2212]$|box of\s*\d+/.test(
                label
            )
        ) {
            return null;
        }

        // Only the final cart CTA — not "+ ADD", not "+ ADD 4 MORE".
        if (isFinalBundleCartLabel(label)) return btn;

        return null;
    }

    function onClickCapture(event) {
        if (!isTargetPage() || _busy) return;

        var atc = isAddToCartTarget(event);
        if (!atc) return;

        if (atc.getAttribute(ALLOW_ATTR) === "1") {
            atc.removeAttribute(ALLOW_ATTR);
            return;
        }

        debugLog("intercepted Simple Bundles ATC", atc);

        try {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        } catch (_) {
            /* ignore */
        }

        _busy = true;
        ensureShippingBeforeAdd()
            .then(function (value) {
                _busy = false;
                if (!value) {
                    debugLog("shipping not selected; ATC blocked");
                    return;
                }
                atc.setAttribute(ALLOW_ATTR, "1");
                try {
                    atc.click();
                } catch (_) {
                    /* ignore */
                }
            })
            .catch(function (err) {
                _busy = false;
                debugLog("ensureShipping error", err);
            });
    }

    var _allowAtcEvent = false;

    function onSimpleBundlesAddToCart(event) {
        if (!isTargetPage()) return;
        if (_allowAtcEvent) {
            _allowAtcEvent = false;
            return;
        }
        if (_busy) {
            try {
                event.preventDefault();
                event.stopImmediatePropagation();
            } catch (_) {
                /* ignore */
            }
            return;
        }

        debugLog("intercepted simple-bundles-byob:add-to-cart");
        try {
            event.preventDefault();
            event.stopImmediatePropagation();
        } catch (_) {
            /* ignore */
        }

        var detail = event.detail;
        _busy = true;
        ensureShippingBeforeAdd()
            .then(function (value) {
                _busy = false;
                if (!value) {
                    debugLog("shipping not selected; add-to-cart event blocked");
                    return;
                }
                _allowAtcEvent = true;
                try {
                    document.dispatchEvent(
                        new CustomEvent("simple-bundles-byob:add-to-cart", {
                            bubbles: true,
                            cancelable: true,
                            detail: detail,
                        })
                    );
                } catch (err) {
                    _allowAtcEvent = false;
                    debugLog("re-dispatch failed", err);
                }
            })
            .catch(function (err) {
                _busy = false;
                debugLog("ensureShipping error", err);
            });
    }

    function observeBundle() {
        mountPanel();

        var observer = new MutationObserver(function () {
            if (_placing || _busy) return;

            window.clearTimeout(_placeTimer);
            _placeTimer = window.setTimeout(function () {
                if (_placing) return;

                var bundle = findByobBundle();
                if (!bundle) {
                    _placedStable = false;
                    return;
                }

                // Wait until the widget upgrades and opens its shadow root.
                if (!bundle.shadowRoot) return;

                var panel = getPanel();
                if (_placedStable && panel && panel.isConnected) return;

                if (!panel || !panel.isConnected) {
                    _panelRef = null;
                    _placedStable = false;
                    mountPanel();
                    return;
                }

                placePanelInSidebar(panel, bundle);
            }, 200);
        });

        observer.observe(document.documentElement, {
            childList: true,
            subtree: true,
        });

        // Custom element upgrade can lag behind first paint.
        var tries = 0;
        var boot = window.setInterval(function () {
            tries += 1;
            var bundle = findByobBundle();
            if (bundle && bundle.shadowRoot) {
                mountPanel();
                var panel = getPanel();
                if (panel) placePanelInSidebar(panel, bundle);
            }
            if (_placedStable || tries > 40) window.clearInterval(boot);
        }, 250);
    }

    function bind() {
        if (!isTargetPage()) return;
        if (document.documentElement.getAttribute(BOUND_ATTR) === "true") return;
        document.documentElement.setAttribute(BOUND_ATTR, "true");

        document.addEventListener("click", onClickCapture, true);
        document.addEventListener(
            "simple-bundles-byob:add-to-cart",
            onSimpleBundlesAddToCart,
            true
        );
        observeBundle();
        debugLog("bound for", (cfg() && cfg().handle) || window.location.pathname);
    }

    if (
        document.readyState === "complete" ||
        document.readyState === "interactive"
    ) {
        bind();
    } else {
        document.addEventListener("DOMContentLoaded", bind);
    }
})();
